import { ModalFooter } from 'reactstrap'

export default ModalFooter
